<template>
  <div id="dashboard" class="container-fluid px-0">
    <section id="seccionCabecera" class="w-100">
      <p class="ps-lg-4 mb-4">
        <span class="fas fa-network-wired fa-lg icon-hover-grow pt-2"></span>
        <span id="cabeceraDashboard" class="text-dark h3 ps-2">{{ $t('dashboardNetwork') }}</span>
      </p>
    </section>
    <section id="fila_carteras" class="row">
      <div class="col-12 mb-5">
        <div v-if="problemaConDatos">
          <problemas-al-cargar />
        </div>
        <div v-else-if="noHayIncidencias">
          <no-hay-incidencias />
        </div>
        <div v-else>
          <table id="no-more-tables" class="table table-striped table-hover text-dark table-rows-clamped">
            <thead>
              <th v-if="this.$store.state.editar"></th>
              <th>ID incidencia</th>
              <th>Dominio</th>
              <th>Severidad</th>
              <th>Descripción</th>
              <th>Estado</th>
              <th>Servicios afectados</th>
              <th>Clientes afectados</th>
              <th>Red/Infr. afectada</th>
              <th>Duración</th>
              <th>Actualizado</th>
              <th>Ultima actualización</th>
            </thead>
            <tbody>
              <tr v-for="(item, index) of conjuntoAlarmas" v-bind:key="index" @click="abrirDetalleFila(item)"
                class="cursor-pointer">
                <td v-if="this.$store.state.editar" class="cursor-pointer" @click.stop>
                  <span v-if="editableIndex === index">
                    <img alt="" height="18" src="../assets/disco-flexible.png" width="18"
                      @click="guardar(index, item.TTNumber)">
                  </span>
                  <span v-else>
                    <img alt="" height="18" src="../assets/editar-texto.png" width="18"
                      @click="editar(index, item.TTNumber)">
                    <img alt="" height="18" src="../assets/papelera-de-reciclaje.png" width="18"
                      v-on:click="activaModalBorrado(index)">
                  </span>
                </td>
                <td class="auto-width-ticket">
                  <span v-if="this.$store.state.editar & editableIndex === index" @click.stop>
                    <input v-model="item.TTNumber" type="text">
                  </span>
                  <span v-else>
                    <div class="line-clamp-table-cell">
                      {{ item.TTNumberToDisplay }}
                    </div>
                  </span>
                </td>
                <td>
                  <div class="line-clamp-table-cell">
                    {{ item.Dominio }}
                  </div>
                </td>
                <td class="auto-width-severity">
                  <div class="line-clamp-table-cell">
                    {{ item.Severity }}
                  </div>
                </td>
                <td>
                  <span v-if="this.$store.state.editar & editableIndex === index" @click.stop>
                    <input v-model="item.Description" type="text">
                  </span>
                  <span v-else>
                    <div class="line-clamp-table-cell" v-b-tooltip.hover="{ title: tooltipText(item.Description), customClass: 'tooltip-ancho' }">
                      {{ item.Description }}
                    </div>
                  </span>
                </td>
                <td>
                  <div class="line-clamp-table-cell">
                    {{ item.Status }}
                  </div>
                </td>
                <td>
                  <div class="line-clamp-table-cell" v-b-tooltip.hover="{ title: tooltipText(item.AffectedServices), customClass: 'tooltip-ancho' }">
                    {{ item.AffectedServices }}
                  </div>
                </td>
                <td>
                  <div class="line-clamp-table-cell" v-b-tooltip.hover="{ title: tooltipText(item.AffectedCustomers), customClass: 'tooltip-ancho' }">
                    {{ item.AffectedCustomers }}
                  </div>
                </td>
                <td>
                  <div class="line-clamp-table-cell" v-b-tooltip.hover="{ title: tooltipText(item.AffectedNodes), customClass: 'tooltip-ancho' }">
                    {{ item.AffectedNodes }}
                  </div>
                </td>
                <td class="auto-width-duracion">
                  <div class="line-clamp-table-cell">
                    {{ item.Duracion }}
                  </div>
                </td>
                <td class="auto-width-fecha">
                  <div class="line-clamp-table-cell">
                    {{ item.UpdateTime }}
                  </div>
                </td>

                <td v-if="this.$store.state.editar & editableIndex === index" class="nav-link active auto-height"
                  @click.stop>
                  <textarea v-model="item.UpdateNotification" rows="4" style="width: 100%; height: 100%;" />
                </td>
                <td v-else class="auto-height">
                  <div class="line-clamp-notification"
                    v-b-tooltip.hover="{ title: item.UpdateNotification, customClass: 'tooltip-ancho' }">
                    {{ item.UpdateNotification }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <BModal id="modalNotificaciones" v-model="mostrarModalDetalle" okOnly="true" okVariant="primary btn btn-block"
            scrollable size="xl" title="Datos de incidencia" titleClass="pl-4" bodyClass="incident-detail-modal-body"
            @shown="onModalDetalleShown">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <h4 class="text-dark text-center">
                    {{ infoModal.TTNumber }}
                  </h4>
                  <table class="table table-hover w-100 incident-detail-table">
                    <tbody>
                      <tr>
                        <th class="modal-label-col">Incident Number:</th>
                        <td>{{ infoModal.TTNumber }}</td>
                      </tr>
                      <tr>
                        <th class="modal-label-col">Severidad:</th>
                        <td>{{ infoModal.Severity }}</td>
                      </tr>
                      <tr>
                        <th class="modal-label-col">Apertura:</th>
                        <td>{{ infoModal.StartTime }}</td>
                      </tr>
                      <tr>
                        <th class="modal-label-col">Descripción:</th>
                        <td>{{ infoModal.Description }}</td>
                      </tr>
                      <tr>
                        <th class="modal-label-col">Estado:</th>
                        <td>{{ infoModal.Status }}</td>
                      </tr>
                      <tr>
                        <th class="modal-label-col">Responsable:</th>
                        <td>{{ infoModal.IncidentManager }}</td>
                      </tr>
                      <tr>
                        <th class="modal-label-col">Servicios afectados:</th>
                        <td>{{ infoModal.AffectedServices }}</td>
                      </tr>
                      <tr>
                        <th class="modal-label-col">Clientes afectados:</th>
                        <td>{{ infoModal.AffectedCustomers }}</td>
                      </tr>
                      <tr>
                        <th class="modal-label-col">Equipos afectados:</th>
                        <td>
                          <expandable-equipment-list ref="equiposAfectados" :key="detalleModalKey" :text="infoModal.AffectedEquipmentList" />
                        </td>
                      </tr>
                      <tr>
                        <th class="modal-label-col">Última actualización:</th>
                        <td>{{ infoModal.UpdateTime }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <h4 class="text-dark text-center pt-8">
                    Histórico de notificaciones
                  </h4>
                  <table class="table table-striped">
                    <thead>
                      <th>Fecha</th>
                      <th>Actualización</th>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) of infoModal.notificaciones" v-bind:key="index">
                        <td class="auto-width-fecha">{{ item.fecha }}</td>
                        <td>{{ item.notificacion }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </BModal>

          <BModal v-model="modalBorrado" title="Confirmación de borrado de incidencia de Red"
            @ok="borrar(indexBorrado, TTBorrado.TTNumber)">
            ¿Estás seguro de que quieres borrar esta incidencia de Red?
            {{ TTBorrado.TTNumberToDisplay }}
          </BModal>
        </div>

      </div>
    </section>

  </div>

</template>

<script>
import auth from '../auth.js';
import { dummyAlarms } from '../dummyAlarms.js';
import { replaceNullAndEmpty } from '../utils.js';
import ProblemasAlCargar from './ProblemasAlCargar.vue';
import NoHayIncidencias from './NoHayIncidencias.vue';
import { BModal } from "bootstrap-vue-next";
import ExpandableEquipmentList from './ExpandableEquipmentList.vue';
import {incidentCellText, incidentDetailTitle} from '../incidentDisplay.js';

export default {
  data() {
    return {
      alarms: dummyAlarms,
      conjuntoAlarmas: [],
      conjuntoAlarmas_ini: [],
      editableIndex: null,
      problemaConDatos: false,
      noHayIncidencias: false,
      tmpAlarmas: [],
      conjuntoUpdates: [],
      mensaje: "Este es el mensaje del pop-up",
      modalContent: '',
      infoModal: {},
      detalleModalKey: 0,
      mostrarModalDetalle: false,
      modalBorrado: false,
      indexBorrado: 1e6,
      TTBorrado: { TTNumber: '', TTNumberToDisplay: '' },
      intervalo: ''
    }
  },
  components: {
    BModal,
    ExpandableEquipmentList,
    ProblemasAlCargar: ProblemasAlCargar,
    NoHayIncidencias: NoHayIncidencias
  },
  created() {
    this.consultarAlarmas();
    this.$store.state.botonEditar = true;
  },
  mounted() {
    this.lanzarCronConsulta()
  },
  methods: {
    tooltipText(value) {
      return value == null ? '' : String(value);
    },
    formatIncidentNumber(inc, oceane, dominio) {
      return incidentDetailTitle(inc, oceane, dominio);
    },
    lanzarCronConsulta() {
      if (this.$store.state.lanzadoCronRed == false) {
        this.$store.state.lanzadoCronRed = true;
        this.intervalo = setInterval(() => {
          this.consultarAlarmas();
        }, 30000);
      }
    },
    activaModalBorrado(index) {
      this.indexBorrado = index;
      this.TTBorrado.TTNumber = this.conjuntoAlarmas[this.indexBorrado].TTNumber;
      this.TTBorrado.TTNumberToDisplay = this.conjuntoAlarmas[this.indexBorrado].TTNumberToDisplay;
      this.modalBorrado = true;
    },
    async abrirDetalleFila(item) {
      const abierto = await this.ampliarInformacion(item.TTNumber, item.Oceane);
      if (!abierto) return;
      this.detalleModalKey += 1;
      this.mostrarModalDetalle = true;
    },
    onModalDetalleShown() {
      this.$refs.equiposAfectados?.scheduleMeasure();
    },
    async consultarAlarmas() {
      if (!(this.$store.state.editar)) {
        try {
          const response = await fetch('api/alarmas/Red', {
            method: 'GET',
            headers: auth.getAuthHeader()
          }
          );
          const data = await response.json();
          if (data.length === undefined) {
            this.problemaConDatos = true;
          } else if (data.length === 0) {
            this.noHayIncidencias = true;
          } else {
            this.problemaConDatos = false;
            this.noHayIncidencias = false;
            this.tmpAlarmas = [];
              for (var i in data) {
                const oceane = data[i].Oceane || '';
                const display = incidentCellText({
                  dominio: data[i].Dominio,
                  ttNumber: data[i].TTNumber,
                  oceane,
                });
                var Alarma = {
                  Severity: data[i].Severity,
                  TTNumber: data[i].TTNumber,
                  TTNumberToDisplay: display.replace(/\//g, '\n').replace(/\+/g, '\n').replace(/ /g, '\n').replace(/\t/g, '\n'),
                  StartTime: data[i].StartTime,
                  Dominio: data[i].Dominio === 'Red/Huawei' ? 'Red' : data[i].Dominio,
                  Duracion: data[i].Duracion,
                  Description: data[i].Description,
                  Status: data[i].Status,
                  AffectedServices: data[i].AffectedServices,
                  AffectedCustomers: data[i].AffectedCustomers,
                  AffectedNodes: data[i].AffectedNodes,
                  IncidentManager: data[i].IncidentManager,
                  UpdateTime: data[i].UpdateTime,
                  UpdateNotification: data[i].UpdateNotification
                };
                var AlarmaProcesada = replaceNullAndEmpty(Alarma, "N/A");
                AlarmaProcesada.Oceane = oceane;
                this.tmpAlarmas.push(AlarmaProcesada);
              }
            this.conjuntoAlarmas = [...this.tmpAlarmas];
          }
        } catch (error) {
          console.error('Error al realizar la consulta de alarmas', error);
        }
      }
    },
    editar(index, TTNumber) {
      this.conjuntoAlarmas_ini = JSON.parse(JSON.stringify(this.conjuntoAlarmas));
      this.editableIndex = index;
    },
    async guardar(index, TTNumber, oceane = false) {
      this.editableIndex = null;
      try {
        const response = await fetch('/api/updateAlarm/', {
          method: 'PUT',
          headers: auth.getAuthHeader(),
          body: JSON.stringify(
            {
              TTNumber: this.conjuntoAlarmas_ini[index].TTNumber,
              UpdateTime: this.conjuntoAlarmas_ini[index].UpdateTime,
              new: this.conjuntoAlarmas[index]
            })
        }
        );
        const data = await response.json();
        this.$store.state.editar = false;
        this.consultarAlarmas();
      } catch (error) {
        console.error("No se pudieron guardar los cambios de la incidencia " + TTNumber + ":", error);
      }
    },
    async borrar(index, TTNumber) {
      this.editableIndex = null;
      try {
        const response = await fetch('/api/deleteAlarm/', {
          method: 'DELETE',
          headers: auth.getAuthHeader(),
          body: JSON.stringify(
            {
              TTNumber: TTNumber
            }
          )
        }
        );
        const data = await response.json();
        this.$store.state.editar = false;
        this.consultarAlarmas();
      } catch (error) {
        console.error("No se pudieron borrar las comunicaciones de la incidencia " + TTNumber + ":", error);
      }
    },
    async ampliarInformacion(TTNumber, oceane) {
      try {
        const response = await fetch('/api/alarmas/detalle/', {
          method: 'POST',
          headers: auth.getAuthHeader(),
          body: JSON.stringify({ id: TTNumber, oceane: oceane || null })
        }
        );
        const data = await response.json();
        if (!response.ok || !Array.isArray(data)) return false;
        const details = data[0]
        this.conjuntoUpdates = [];

        const updatesData = data.map((item) => {
          return {
            fecha: item.UpdateTime,
            notificacion: item.UpdateNotification
          }
        })

        this.infoModal = {
          Severity: details.Severity,
          TTNumber: this.formatIncidentNumber(details.TTNumber, details.Oceane, details.Dominio),
          StartTime: details.StartTime,
          Description: details.Description,
          Status: details.Status,
          AffectedServices: details.AffectedServices ?? "No disponible",
          AffectedNodes: details.AffectedNodes ?? "No disponible",
          AffectedEquipmentList: details.AffectedEquipmentList ?? "No disponible",
          AffectedCustomers: details.AffectedCustomers ?? "No disponible",
          IncidentManager: details.IncidentManager ?? "No disponible",
          UpdateTime: details.UpdateTime ?? "No disponible",
          UpdateNotification: details.UpdateNotification ?? "No disponible",
          notificaciones: updatesData
        }
        return true;
      } catch (error) {
        console.error("No se pudo recuperar la información de la incidencia " + TTNumber + ":", error);
        return false;
      }
    }
  }
}
</script>

<style>
.tooltip-ancho .tooltip-inner {
  max-width: 500px !important;
  text-align: left !important;
  width: max-content;
  white-space: pre-line;
  word-break: break-word;
}

.table-rows-clamped {
  table-layout: fixed;
  width: 100%;
}

.cursor-pointer {
  cursor: pointer;
}

.modal-label-col {
  width: 200px;
  white-space: nowrap;
  vertical-align: top;
}

.incident-detail-table {
  table-layout: fixed;
  width: 100%;
}

.incident-detail-table td {
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}
</style>

<style scoped>
.line-clamp-table-cell {
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  white-space: pre-wrap;
}

.line-clamp-notification {
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  white-space: pre-wrap;
}
</style>